import { render, staticRenderFns } from "./PackageIncomeReport.vue?vue&type=template&id=72cb276f&lang=pug&"
import script from "./PackageIncomeReport.vue?vue&type=script&lang=ts&"
export * from "./PackageIncomeReport.vue?vue&type=script&lang=ts&"
import style0 from "./PackageIncomeReport.vue?vue&type=style&index=0&id=72cb276f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports